// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgShare24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19.75 6C19.75 4.20507 18.2949 2.75 16.5 2.75C14.7051 2.75 13.25 4.20507 13.25 6C13.25 6.34312 13.3032 6.67383 13.4017 6.98432L8.82576 9.7299C8.23557 9.12533 7.41162 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.41162 15.25 8.23557 14.8747 8.82576 14.2701L13.4017 17.0157C13.3032 17.3262 13.25 17.6569 13.25 18C13.25 19.7949 14.7051 21.25 16.5 21.25C18.2949 21.25 19.75 19.7949 19.75 18C19.75 16.2051 18.2949 14.75 16.5 14.75C15.5884 14.75 14.7644 15.1253 14.1742 15.7299L9.59827 12.9843C9.69683 12.6738 9.75 12.3431 9.75 12C9.75 11.6569 9.69683 11.3262 9.59827 11.0157L14.1742 8.2701C14.7644 8.87467 15.5884 9.25 16.5 9.25C18.2949 9.25 19.75 7.79493 19.75 6ZM14.75 6C14.75 5.0335 15.5335 4.25 16.5 4.25C17.4665 4.25 18.25 5.0335 18.25 6C18.25 6.9665 17.4665 7.75 16.5 7.75C15.5335 7.75 14.75 6.9665 14.75 6ZM4.75 12C4.75 11.0335 5.5335 10.25 6.5 10.25C7.4665 10.25 8.25 11.0335 8.25 12C8.25 12.9665 7.4665 13.75 6.5 13.75C5.5335 13.75 4.75 12.9665 4.75 12ZM16.5 16.25C15.5335 16.25 14.75 17.0335 14.75 18C14.75 18.9665 15.5335 19.75 16.5 19.75C17.4665 19.75 18.25 18.9665 18.25 18C18.25 17.0335 17.4665 16.25 16.5 16.25Z"
				/>
			</Svg>
		);
	}
);
SvgShare24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgShare24;
